import { render } from "./HeroSection.vue?vue&type=template&id=28c2e0e9&scoped=true"
import script from "./HeroSection.vue?vue&type=script&lang=js"
export * from "./HeroSection.vue?vue&type=script&lang=js"

import "./HeroSection.vue?vue&type=style&index=0&id=28c2e0e9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-28c2e0e9"

export default script